import { fetchVersionFromDocument } from "@/app-updator";
import { httpClient } from "@/app/client/httpClient";
import { authStore } from "@/store/auth";
import { deviceModule } from "@/store/device";
import { BankBranches } from "@/types/system/BankBranches";

// ログを追いやすくするためにcontextIdを定義
const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
let randomContextId = "";
for (let i = 0; i < 8; i++) {
  randomContextId += chars.charAt(Math.floor(Math.random() * chars.length));
}

class SystemService {
  async log(query: { event: string; route_name?: string }) {
    // @ts-ignore
    // deviceはcordova-plugin-deviceで定義されており
    // 初期化時には使えないのでこのタイミングで取得する
    const applicationContextId = window.device?.uuid || randomContextId;

    /* eslint-disable @typescript-eslint/naming-convention */
    // @ts-ignore
    query.application_context_id = applicationContextId;
    // @ts-ignore
    query.version_no = deviceModule.versionNo || "";
    // @ts-ignore
    query.build_version = fetchVersionFromDocument() || "";
    // @ts-ignore
    query.username = authStore.user?.username || "";
    /* eslint-enable */

    // 処理自体は非同期で行うが、エラーが発生しても何もしないため、無名関数を作って即時実行する
    try {
      await httpClient.system.access_log.log.$get({
        config: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          paramsSerializer: (params: { [x: string]: any }) => {
            const clonedParams = { ...params };
            delete clonedParams.event;
            delete clonedParams.route_name;
            const ar = Object.keys(clonedParams).sort();
            // Athenaで操作しやすいようにrouteName, eventを先頭に持ってくる
            ar.unshift("event");
            ar.unshift("route_name");
            return ar
              .map(key => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(
                  params[key]
                )}`;
              })
              .join("&");
          }
        },
        query
      });
    } catch {
      // 何もしない
    }
  }

  fetchMaster() {
    return httpClient.system.masters.all.$get();
  }

  fetchReferPromotionPoint() {
    return httpClient.system.refer_promotion_point.point.$get();
  }

  fetchMasterBankBranches(bankCode: string): Promise<BankBranches> {
    return httpClient.system.masters.banks._bank_code(bankCode).branches.$get();
  }
}

export const systemService = new SystemService();
